import { render, staticRenderFns } from "./StarHotel.vue?vue&type=template&id=782170f8&scoped=true&"
import script from "./StarHotel.vue?vue&type=script&lang=js&"
export * from "./StarHotel.vue?vue&type=script&lang=js&"
import style0 from "./StarHotel.vue?vue&type=style&index=0&id=782170f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782170f8",
  null
  
)

export default component.exports